import { useAsync } from '@tumelo/react'
import React, { use, useState } from 'react'
import { FeatureFlag } from '../proto/tumelo/stewardshipbff/v1/feature_flag'
import { ClientContext } from './client'

export const FlagsContext = React.createContext<{
  flags: Map<FeatureFlag['key'], FeatureFlag['state']>
  isLoading: boolean
}>({
  flags: new Map(),
  isLoading: true,
})

export const FlagsContextProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const getClient = use(ClientContext)

  const [items, setItems] = useState(new Map())

  const { status } = useAsync(async () => {
    const client = await getClient()
    const { featureFlags } = await client.ListFeatureFlags({})
    const flagsMap = new Map()
    featureFlags.forEach((item) => {
      flagsMap.set(item.key, item.state)
    })
    setItems(flagsMap)
  })

  return <FlagsContext value={{ flags: items, isLoading: status === 'pending' }}>{children}</FlagsContext>
}
